(() => {
  angular.module('app').component('clinicPatientTicketAttachments', {
    templateUrl: require('./widget.html'),
    controller: ClinicPatientTicketAttachments,
    controllerAs: 'vm',
    bindings: {
      isDisabled: '<',
      isExpanded: '=',
      isCompleted: '<',
      onDirtyEvent: '<',
      onSetPristineEvent: '<',
      isCreate: '<',
      ticket: '<',
      newAttachments: '=',
      onComplete: '&',
    },
  });

  ClinicPatientTicketAttachments.$inject = ['$scope'];

  function ClinicPatientTicketAttachments($scope) {
    const vm = this;

    vm.hasGPTicketEnhancement = abp.setting.getBoolean('Hms.Feature.GPTicketEnhancement');

    vm.isCreate = !vm.ticket.id;
    vm.isTouched = false;
    vm.isAttachmentsInvalid = false;
    vm.isNewAttachmentsInvalid = false;
    vm.uploadConfig = {
      objectType: 'TicketAttachment',
    };
    vm.checklistItems = [
      {
        isChecked: false,
        isMandatory: true,
        isSelected: false,
        required: true,
        text: App.localize('HealthScreeningPackages'),
      },
      {
        isChecked: false,
        isMandatory: true,
        isSelected: false,
        required: true,
        text: App.localize('Billing'),
      },
    ];

    vm.$onChanges = onChanges;
    vm.onDirtyEventHandler = onDirtyEventHandler;
    vm.onSetPristineEventHandler = onSetPristineEventHandler;
    vm.next = next;

    $scope.attachments = vm.ticket.attachments;
    $scope.newAttachments = vm.newAttachments;

    $scope.$watch(
      'attachments',
      (newValue) => {
        if (vm.isTouched || (newValue && newValue.length !== 0)) vm.isTouched = true;
        validateAttachments();
      },
      true
    );

    $scope.$watch(
      'newAttachments',
      (newValue) => {
        if (vm.isTouched || newValue.length !== 0) vm.isTouched = true;
        if (vm.isTouched) validateNewAttachments();
      },
      true
    );

    function onChanges(changes) {
      if (changes.onDirtyEvent && changes.onDirtyEvent.currentValue) {
        vm.onDirtyEvent.handler = vm.onDirtyEventHandler;
      }

      if (changes.onSetPristineEvent && changes.onSetPristineEvent.currentValue) {
        vm.onSetPristineEvent.handler = vm.onSetPristineEventHandler;
      }
    }

    function onDirtyEventHandler() {
      return vm.attachmentsForm.$dirty;
    }

    function onSetPristineEventHandler() {
      vm.attachmentsForm.$setPristine();
    }

    function validateAttachments() {
      var isNotDeleted = _.find(vm.ticket.attachments, (a) => {
        return !a.isDelete;
      });
      vm.isAttachmentsInvalid = isNotDeleted === undefined;
    }

    function validateNewAttachments() {
      vm.isNewAttachmentsInvalid = vm.newAttachments.length === 0;
    }

    function next() {
      validateAttachments();
      validateNewAttachments();

      const isInvalid = vm.isAttachmentsInvalid && vm.isNewAttachmentsInvalid;

      if (App.isFormValid(vm.attachmentsForm) && !isInvalid && !vm.isCheckboxesInvalid) {
        vm.onComplete();
        vm.invalidChecklist = false;
      } else {
        vm.invalidChecklist = true;
      }
    }
  }
})();
